import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useMaterialGridMaxItems } from '$/hooks/useMaterialGridMaxItems';
import { LoadingInspirationCard } from '$/pages/DashboardPages/pages/Inspiration/components/InspirationCard/LoadingInspirationCard';
import { InspirationCard } from '$/pages/DashboardPages/pages/Welcome/components/InspirationSection/components/InspirationCard';
import { allInspirationsQuery } from '$/services/usecases/inspirations/queries';
import { useLastSeenStore } from '$/stores/useLastSeenStore';
import { repeat } from '$/utils/arrayUtils';

export const InspirationRow = () => {
  const { t } = useTranslation();

  const itemLimit = useMaterialGridMaxItems();
  const lastScenes = useLastSeenStore.useLastScenes();
  const inspirations = useQuery(allInspirationsQuery());

  const highlightedInspirations = useMemo(() => {
    const allInspirations = inspirations.data?.response.payload ?? [];

    const shownInspirations = [...lastScenes]
      .reverse()
      .slice(0, itemLimit)
      .map((current) => allInspirations.find((i) => i.id === current.id))
      .filter((scene) => scene !== undefined);

    if (shownInspirations.length < itemLimit) {
      allInspirations.forEach((inspiration) => {
        const isInspiration = shownInspirations.some(
          (shown) => shown.id === inspiration.id,
        );
        if (!isInspiration && shownInspirations.length < itemLimit) {
          shownInspirations.push(inspiration);
        }
      });
    }

    return shownInspirations;
  }, [inspirations.data?.response.payload, lastScenes, itemLimit]);

  if (inspirations.isLoading) {
    return repeat(itemLimit).map((i) => (
      <LoadingInspirationCard key={i} id={i} onlyNormalSize />
    ));
  }

  return highlightedInspirations.map((inspiration) => (
    <InspirationCard
      key={inspiration.id}
      id={inspiration.id}
      label={t(`dashboard.inspiration.scenes.${inspiration.category}`)}
    />
  ));
};
